export const GoogleAdsType = {
  SET_FILTERS: 'GADS_SET_FILTERS',

  FETCH_HOURLY_COC_REQUEST: 'GADS_FETCH_HOURLY_COC_REQUEST',
  FETCH_HOURLY_COC_SUCCESS: 'GADS_FETCH_HOURLY_COC_SUCCESS',
  FETCH_HOURLY_COC_FAILURE: 'GADS_FETCH_HOURLY_COC_FAILURE',

  FETCH_HIGHEST_COST_KW_REQUEST: 'GADS_FETCH_HIGHEST_COST_KW_REQUEST',
  FETCH_HIGHEST_COST_KW_SUCCESS: 'GADS_FETCH_HIGHEST_COST_KW_SUCCESS',
  FETCH_HIGHEST_COST_KW_FAILURE: 'GADS_FETCH_HIGHEST_COST_KW_FAILURE',

  FETCH_LOWEST_CONV_KW_REQUEST: 'GADS_FETCH_LOWEST_CONV_KW_REQUEST',
  FETCH_LOWEST_CONV_KW_SUCCESS: 'GADS_FETCH_LOWEST_CONV_KW_SUCCESS',
  FETCH_LOWEST_CONV_KW_FAILURE: 'GADS_FETCH_LOWEST_CONV_KW_FAILURE',

  FETCH_CAMPAIGNS_REQUEST: 'GADS_FETCH_CAMPAIGNS_REQUEST',
  FETCH_CAMPAIGNS_SUCCESS: 'GADS_FETCH_CAMPAIGNS_SUCCESS',
  FETCH_CAMPAIGNS_FAILURE: 'GADS_FETCH_CAMPAIGNS_FAILURE',

  FETCH_AD_GROUPS_REQUEST: 'GADS_FETCH_AD_GROUPS_REQUEST',
  FETCH_AD_GROUPS_SUCCESS: 'GADS_FETCH_AD_GROUPS_SUCCESS',
  FETCH_AD_GROUPS_FAILURE: 'GADS_FETCH_AD_GROUPS_FAILURE',

  FETCH_SYNC_STATUS_REQUEST: 'GADS_FETCH_SYNC_STATUS_REQUEST',
  FETCH_SYNC_STATUS_SUCCESS: 'GADS_FETCH_SYNC_STATUS_SUCCESS',
  FETCH_SYNC_STATUS_FAILURE: 'GADS_FETCH_SYNC_STATUS_FAILURE',
};
